import { render, staticRenderFns } from "./NotifUser.vue?vue&type=template&id=0b1de560&scoped=true"
import script from "./NotifUser.vue?vue&type=script&lang=js"
export * from "./NotifUser.vue?vue&type=script&lang=js"
import style0 from "./NotifUser.vue?vue&type=style&index=0&id=0b1de560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1de560",
  null
  
)

export default component.exports